import { useEffect, useRef, useState } from 'react';

export default function SoccerGame() {
  const canvasRef = useRef(null);
  const screenRef = useRef(null);
  const [started, setStarted] = useState(false);

  const startGame = () => {
    if (started) return;
    setStarted(true);

    const canvas = canvasRef.current;
    const screen = screenRef.current;
    canvas.width = screen.offsetWidth;
    canvas.height = screen.offsetHeight;
    const ctx = canvas.getContext('2d');
    const W = canvas.width, H = canvas.height;

    let phase = 'aim';
    let aimX = W / 2, score = 0, misses = 0, maxMisses = 3;
    let ballAnim = null, keeperPos = 0.5, keeperDir = 1;
    let resultMsg = '', resultColor = '#F5A623';
    let frameId;

    function drawField() {
      const grass = ctx.createLinearGradient(0, H * 0.35, 0, H);
      grass.addColorStop(0, '#1a4020'); grass.addColorStop(1, '#0d2810');
      ctx.fillStyle = grass; ctx.fillRect(0, H * 0.35, W, H);
      ctx.fillStyle = '#0e1820'; ctx.fillRect(0, 0, W, H * 0.35);
      ctx.fillStyle = 'rgba(255,255,255,0.4)';
      for (let i = 0; i < 12; i++) ctx.fillRect(i * W / 12 + 5, i % 3 * 25 + 10, 2, 2);
      const gw = W * 0.55, gh = H * 0.3;
      const gx = (W - gw) / 2, gy = H * 0.12;
      ctx.strokeStyle = '#fff'; ctx.lineWidth = 3;
      ctx.strokeRect(gx, gy, gw, gh);
      ctx.lineWidth = 0.5; ctx.strokeStyle = 'rgba(255,255,255,0.2)';
      for (let i = 1; i < 5; i++) { ctx.beginPath(); ctx.moveTo(gx + i * gw / 5, gy); ctx.lineTo(gx + i * gw / 5, gy + gh); ctx.stroke(); }
      for (let i = 1; i < 3; i++) { ctx.beginPath(); ctx.moveTo(gx, gy + i * gh / 3); ctx.lineTo(gx + gw, gy + i * gh / 3); ctx.stroke(); }
    }

    function loop() {
      ctx.clearRect(0, 0, W, H);
      drawField();

      if (misses >= maxMisses) {
        cancelAnimationFrame(frameId);
        ctx.fillStyle = 'rgba(0,0,0,0.75)'; ctx.fillRect(0, 0, W, H);
        ctx.fillStyle = '#F5A623'; ctx.font = `bold ${W * 0.07}px Cairo`; ctx.textAlign = 'center';
        ctx.fillText('انتهت اللعبة!', W / 2, H * 0.4);
        ctx.fillStyle = '#fff'; ctx.font = `bold ${W * 0.05}px Cairo`;
        ctx.fillText('أهدافك: ' + score, W / 2, H * 0.54);
        ctx.fillStyle = '#F5A623'; ctx.font = `bold ${W * 0.035}px Cairo`;
        ctx.fillText('اضغط للعب تاني', W / 2, H * 0.66);
        canvas.onclick = () => { setStarted(false); };
        return;
      }

      const gx = (W - W * 0.55) / 2, gw = W * 0.55;

      if (phase === 'aim') {
        keeperPos += keeperDir * 0.012;
        if (keeperPos > 0.85 || keeperPos < 0.15) keeperDir *= -1;
        ctx.font = `${H * 0.14}px serif`; ctx.textAlign = 'center';
        ctx.fillText('🧤', gx + keeperPos * gw, H * 0.37);
        ctx.font = `${H * 0.08}px serif`;
        ctx.fillText('⚽', W / 2, H * 0.8);
        ctx.fillStyle = 'rgba(245,166,35,0.8)';
        const ay = H * 0.72;
        ctx.beginPath(); ctx.moveTo(aimX, ay - 20); ctx.lineTo(aimX - 12, ay); ctx.lineTo(aimX + 12, ay); ctx.closePath(); ctx.fill();
        ctx.strokeStyle = 'rgba(245,166,35,0.4)'; ctx.lineWidth = 2; ctx.setLineDash([4, 4]);
        ctx.beginPath(); ctx.moveTo(aimX, ay); ctx.lineTo(aimX, H * 0.38); ctx.stroke();
        ctx.setLineDash([]);
        ctx.fillStyle = 'rgba(255,255,255,0.7)'; ctx.font = `bold ${W * 0.038}px Cairo`; ctx.textAlign = 'center';
        ctx.fillText('اسحب لتغيير الاتجاه — اضغط لتسديد!', W / 2, H * 0.92);
      } else if (phase === 'kick') {
        const t = (Date.now() - ballAnim.startTime) / 500;
        const bx = W / 2 + (ballAnim.targetX - W / 2) * t;
        const by = H * 0.8 - H * 0.45 * t;
        ctx.font = `${H * 0.14}px serif`; ctx.textAlign = 'center';
        ctx.fillText('🧤', gx + ballAnim.keeperFinalPos * gw, H * 0.37);
        ctx.font = `${H * 0.08}px serif`; ctx.fillText('⚽', bx, by);
        if (t >= 1) { phase = 'result'; setTimeout(() => { phase = 'aim'; resultMsg = ''; }, 1200); }
      } else if (phase === 'result') {
        ctx.font = `${H * 0.14}px serif`; ctx.textAlign = 'center';
        ctx.fillText('🧤', gx + ballAnim.keeperFinalPos * gw, H * 0.37);
        ctx.font = `${H * 0.08}px serif`; ctx.fillText('⚽', ballAnim.targetX, H * 0.32);
        ctx.fillStyle = resultColor; ctx.font = `bold ${W * 0.1}px Cairo`; ctx.textAlign = 'center';
        ctx.fillText(resultMsg, W / 2, H * 0.63);
      }

      ctx.fillStyle = '#F5A623'; ctx.font = `bold ${W * 0.05}px Cairo`; ctx.textAlign = 'right';
      ctx.fillText('⚽ ' + score, W - 16, 26);
      ctx.fillStyle = '#e63946';
      ctx.fillText('❌ ' + misses + '/' + maxMisses, W - 16, 50);

      frameId = requestAnimationFrame(loop);
    }

    const shoot = () => {
      if (phase !== 'aim') return;
      const gx2 = (W - W * 0.55) / 2, gw2 = W * 0.55;
      const targetX = aimX, kFinal = keeperPos;
      const inGoal = targetX >= gx2 + 15 && targetX <= gx2 + gw2 - 15;
      const kx = gx2 + kFinal * gw2;
      const saved = inGoal && Math.abs(kx - targetX) < gw2 * 0.18;
      ballAnim = { startTime: Date.now(), targetX, keeperFinalPos: kFinal };
      phase = 'kick';
      setTimeout(() => {
        if (inGoal && !saved) { score++; resultMsg = 'هدف! 🔥'; resultColor = '#00C851'; }
        else if (saved) { misses++; resultMsg = 'صدّها! 🧤'; resultColor = '#e63946'; }
        else { misses++; resultMsg = 'خارج! ❌'; resultColor = '#e63946'; }
      }, 480);
    };

    canvas.addEventListener('mousemove', (e) => {
      if (phase !== 'aim') return;
      const r = canvas.getBoundingClientRect();
      aimX = (e.clientX - r.left) * (W / r.width);
    });
    canvas.addEventListener('touchmove', (e) => {
      if (phase !== 'aim') return;
      e.preventDefault();
      const r = canvas.getBoundingClientRect();
      aimX = (e.touches[0].clientX - r.left) * (W / r.width);
    }, { passive: false });
    canvas.onclick = shoot;

    loop();
  };

  return (
    <div className="demo-screen" ref={screenRef} onClick={!started ? startGame : undefined}>
      <div className="demo-canvas">
        <canvas ref={canvasRef} />
      </div>
      {!started && (
        <div className="play-overlay">
          <div className="play-btn-big">▶</div>
          <div className="play-hint">اضغط للعب</div>
        </div>
      )}
    </div>
  );
}
